import { render, staticRenderFns } from "./counseling.vue?vue&type=template&id=9615fb48&"
import script from "./counseling.vue?vue&type=script&lang=js&"
export * from "./counseling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports